'use client';

import { FC } from 'react';

import { ClientSideError } from '@telialt/core-eshop/src/components/ClientSideError/ClientSideError';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

type Props = {
    error: Error;
};

const ProductPageB2BError: FC<Props> = ({ error }) => {
    return <ClientSideError error={error} component={DDComponent.EshopProduct} />;
};
export default ProductPageB2BError;
